module.exports = __webpack_public_path__ + "assets/cover_3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_3.jpg
 ** module id = 111
 ** module chunks = 1
 **/